export enum NotificationMessageSubstitutionsEnum {
    INDICATED_NAME = '##INDICATED_NAME##',
    WHO_INDICATES_NAME = '##WHO_INDICATES_NAME##',
    GOAL_NAME = '##GOAL_NAME##',
    GOAL_PRIZE = '##GOAL_PRIZE##',
}

